<div class="hold-transition login-page" [ngClass]="bgclass">
  <div class="login-box" *ngIf="!new">

    <div class="text-center" *ngIf="!projects">
      <div class="spinner-border" style="width: 2rem; height: 2rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div *ngIf="projects">
      <div class="card m-3" style="background-color: #e9ecef;" *ngFor="let project of projects"
        (click)="projectInitializer(project)">
        <div class="card-body login-card-body">
          <div style="display: inline-flex;">
            <img src="assets/PrismaPlaza.png" alt="" height="60px" *ngIf="project.name === 'Prisma Plaza'">
            <img src="assets/PrismaCity.png" alt="" height="60px" *ngIf="project.name === 'Prisma City'">
            <p class="ptitle" style="padding-left: 20px; align-self: center;">{{project.name}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="text-center">
      <a href="javascript:void(0);"(click)="newProject()" >create a new project</a>
    </div> -->

  </div>

  <div class="login-box" style="width: 90%;" *ngIf="new">
    <div class="login-logo">
      <a><b>Create a NEw Project</b></a>
    </div>

    <section class="content">
      <form [formGroup]="projectForm" (ngSubmit)="onSubmit();" autocomplete="off">
        <div class="row">
          <div class="col-md-6">
            <div class="card card-primary">
              <div class="card-body" style="display: block;">
                <div class="form-group">
                  <label for="name">Name</label>
                  <input type="text" id="name" class="form-control" formControlName="name" required>
                </div>
                <div class="form-group">
                  <label for="type">Project type</label>
                  <select id="type" class="form-control custom-select" formControlName="type">
                    <option value="commercial">Commercial</option>
                    <option value="residential">Residential</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="property_type">Property Type</label>
                  <input type="tel" id="property_type" class="form-control" formControlName="property_type">
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="edc">EDC</label>
                    <input type="number" id="edc" class="form-control" formControlName="edc">
                  </div>
                  <div class="form-group col-md-6">
                    <label for="gst">GST</label>
                    <input type="number" id="gst" class="form-control" formControlName="gst">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card card-secondary">
              <div class="card-body">
                <div class="form-group">
                  <label for="base_price">Base Price</label>
                  <input type="number" id="base_price" class="form-control" formControlName="base_price">
                </div>
                <div formArrayName="plc">
                  <div class="form-group" *ngFor="let group of plcArray.controls; let i = index;" [formGroupName]="i">
                    <label>PLC {{i+1}}</label>
                    <div class="row">
                      <div class="col-md-5">
                        <input type="text" placeholder="plc name" class="form-control" formControlName="plc_name">
                      </div>
                      <div class="col-md-5">
                        <input type="number" placeholder="price" class="form-control" formControlName="price">
                      </div>
                      <div class="col-md-2">
                        <button type="button" class="btn btn-sm btn-outline-danger" *ngIf="i !=0"
                          (click)="removePlc(i)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn-sm btn-outline-secondary my-2" (click)="addPlc()">Add more</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4 pt-2 text-center">

            <button class="btn btn-outline-secondary mx-2" type="button" (click)="cancel();">cancel</button>

            <input type="submit" value="Create" class="btn btn-primary" *ngIf="!loading">

            <button class="btn btn-primary" type="button" disabled *ngIf="loading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              creating...
            </button>

          </div>
        </div>
      </form>
    </section>


  </div>
</div>
